import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { ProjectType, PropertyType, ProjectStage, LoanPurpose } from 'app/core/models/account.types';
import { LoansService } from 'app/modules/projects/details/loans/loans.service';
import { LoanRequest } from '../../loans.types';
import { take } from 'rxjs';

@Component({
  selector: 'project-loan-requests-add',
  templateUrl: './add-loan-request.component.html',
  styleUrls: ['./add-loan-request.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectAddLoanRequestComponent implements OnInit {
  loanRequestForm: UntypedFormGroup;
  projectTypes: ProjectType[];
  propertyTypes: PropertyType[];
  projectStages: ProjectStage[];
  loanRequest: LoanRequest;
  loanPurposes: LoanPurpose[];
  public uploadedFile: any;
  options: [];
  public isLoading: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ProjectAddLoanRequestComponent>,
    private readonly _formBuilder: UntypedFormBuilder,
    private readonly _router: Router,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _loansService: LoansService,
  ) {}

  ngOnInit(): void {
    // Create the form
    this.loanRequestForm = this._formBuilder.group({
      id: [''],
      loan_purpose_id: ['', [Validators.required]],
      description: ['', [Validators.required]],
    });
    this.loanPurposes = this.data.loanPurposes;

    if (this.data.loanRequest) {
      this.loanRequest = this.data.loanRequest;
      this.loanRequestForm.patchValue(this.loanRequest);
    }
  }

  public get isSaveBtnDisabled(): boolean {
    return this.isLoading || this.loanRequestForm.pristine || this.loanRequestForm.invalid;
  }

  onFileChanged($event) {
    let file = $event.target.files[0];
    this.uploadedFile = file;
  }

  discard(): void {
    this.matDialogRef.close();
  }

  save(): void {
    this.loanRequestForm.disable();

    let loanRequest = this.loanRequestForm.value;
    if (loanRequest.id) {
      this._loansService.updateLoanRequest(loanRequest).subscribe((response) => {
        this.matDialogRef.close();
      });
    } else {
      this._loansService.createLoanRequest(loanRequest).subscribe((response) => {
        let route = this._activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }

        route.url.pipe(take(1)).subscribe((url) => {
          if (url?.length) {
            this._router.navigate(['../', response.id], { relativeTo: route });
          } else {
            this._router.navigate(['./', response.id], { relativeTo: route });
          }
        });

        this.matDialogRef.close();
      });
    }
  }

  // Function attached to debounce-click directive to flag the button's disable state.
  public isDebounceLoading(isLoading: boolean): boolean {
    return (this.isLoading = isLoading);
  }
}
